/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/common-utils';
import { css } from '@emotion/core';
import { Colors, Icon } from '@zapier/design-system';
import { statusMap } from '@zapier/design-system-reporting';

const root = (color: string, size: number) =>
  css`
    align-items: center;
    background-color: ${color};
    border-radius: 50%;
    display: flex;
    height: ${size}px;
    justify-content: center;
    width: ${size}px;
    margin-right: 10px;
  `;

const miscHand = css`
  > span {
    margin-left: -2px;
  }
`;

const playing = css`
  position: relative;

  &:after {
    border: 3px solid ${Colors.orange500};
    border-left-color: transparent;
    border-radius: 50%;
    bottom: -0.5px;
    content: ' ';
    left: -0.5px;
    position: absolute;
    right: -0.5px;
    top: -0.5px;
    transform: rotate(45deg);
  }
`;

export function TaskStatusIconV2({ status, size = 30 }: any) {
  const statusInfo = statusMap[status];

  return statusInfo ? (
    <div
      css={[
        root(statusInfo.color, size),
        statusInfo.icon === 'miscHand' && miscHand,
        statusInfo.icon === 'actionPlay' && playing,
      ]}
    >
      <Icon
        color={statusInfo.iconColor || 'white'}
        name={statusInfo.icon}
        size={size / 2}
      />
    </div>
  ) : null;
}
